"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = _interopRequireDefault(require("./styles"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _ChevronUp = _interopRequireDefault(require("mdi-material-ui/ChevronUp"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ScrollToTop = _ref => {
  var {
    visibleYOffset
  } = _ref;
  var classes = (0, _styles.default)();
  var [visible, setVisible] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (window) {
      window.addEventListener('scroll', onScroll, {
        passive: true
      });
    }
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  var onScroll = () => {
    setVisible(window.pageYOffset > visibleYOffset);
  };
  var handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return visible && /*#__PURE__*/_react.default.createElement(_Paper.default, {
    elevation: 3,
    square: true,
    classes: {
      root: classes.paper
    },
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_ChevronUp.default, {
    className: classes.chevron,
    fontSize: "large"
  }));
};
var _default = exports.default = ScrollToTop;